import React from "react";
import "../styles/AboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-container">
      <h1>Our History</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur
        enim quos dicta facilis ad et nihil labore cumque eos iusto saepe
        officia consequuntur nobis a commodi, sint necessitatibus eum quo!
      </p>
      <h1>Our Mission</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur
        enim quos dicta facilis ad et nihil labore cumque eos iusto saepe
        officia consequuntur nobis a commodi, sint necessitatibus eum quo!
      </p>
      <h1>Our Vision</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur
        enim quos dicta facilis ad et nihil labore cumque eos iusto saepe
        officia consequuntur nobis a commodi, sint necessitatibus eum quo!
      </p>
    </div>
  );
};

export default AboutUs;
